module.exports = __webpack_public_path__ + "static/media/FolderBlueDark.9364ed80.svg";